<span *ngIf="billStatus | paymentState" class="status" [ngClass]="(billStatus | paymentState : false).toLowerCase()">
  {{ billStatus | paymentState | translate }}
  <span *ngIf="showValue && ![undefined, null].includes(billStatus)">({{ billStatus }})</span>
</span>
